import { render } from "./PartnerLaneHealth.vue?vue&type=template&id=14865a16"
import script from "./PartnerLaneHealth.vue?vue&type=script&lang=js"
export * from "./PartnerLaneHealth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__